<template>
  <div :class="['input-wrapper', { 'input-error': hasError }]">
    <input :type="passwordVisible ? 'text' : 'password'"
            v-model="password"
            @input="isUserNameValid"
            @keyup.enter="keyupHandler"
            placeholder="Password"
            autocomplete="off" />
    <EyeButton @click="togglePasswordVisibility" />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import EyeButton from './EyeButton.vue';

const password = ref('')
const passwordVisible = ref(false)
const hasError = ref(false)

const togglePasswordVisibility = () => {
  passwordVisible.value = !passwordVisible.value
}

const emit = defineEmits(['update:input', 'update:enter'])

const isUserNameValid = () => {
  hasError.value = false
  emit('update:input', password.value)
}

const keyupHandler = (event) => {
  if (event.key === 'Enter') {
    if (password.value === '' || hasError.value) {
      return
    }
    emit('update:enter', event)
  }
}

const getPassword = () => password.value

const setErrorState = (state) => {
  hasError.value = state
}

defineExpose({
  getPassword,
  setErrorState,
})
</script>

<style scoped>
.input-wrapper {
  width: 240px;
  height: 30px;
  display: flex;
  align-items: center;
  border: 1px solid #D8DADC;
  border-radius: 4px;
  padding: 4px;
  box-sizing: border-box;
  &:hover {
    border-color: #C4C6C8;
  }
}

.input-wrapper.input-error {
  background-color: #FFF2F4;
  border-color: #FA899C;
  &:hover {
    border-color: #FA899C;
  }
}

.input-wrapper input {
  border: none;
  outline: none;
  padding: 4px;
  flex-grow: 1;
  background-color: transparent;
  &:hover {
    border-color: #C4C6C8;
  }
}

.input-wrapper input::placeholder {
  color: var(--Color-Font-color_font_tier3, #BABCBE);
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  user-select: none;
  -webkit-user-select: none;
}

@media (max-width: 624px) {
  .input-wrapper {
    width: 240px;
    height: 30px;
    display: flex;
    align-items: center;
    border: 1px solid #D8DADC;
    border-radius: 4px;
    padding: 4px;
    box-sizing: border-box;
    width: 100%;
  }
  .input-wrapper input {
    line-height: 28px;
    border: none;
    outline: none;
    padding: 4px;
    flex-grow: 1;
    background-color: transparent;
    width: 100%;
  }
}

</style>